import { DialogActions, DialogContent } from '@startuptools/ui/Dialog';
import { Dialog, DialogTitle } from '@startuptools/ui/Dialog';
import { Input } from '@startuptools/ui/Input';
import { Button } from '@startuptools/ui/joy/Button';
import { FormControl } from '@startuptools/ui/joy/FormControl';
import { FormLabel } from '@startuptools/ui/joy/FormLabel';
import { Controller, SubmitHandler, useForm } from 'react-hook-form';
import { toast } from '@startuptools/ui/toast/use-toast';
import { useCompanyId } from '@startuptools/common/react-wrapper';
import { Trans } from '@lingui/react';
import { FileViewDocument, useCreateFolderMutation, type GqlCreateFolderMutationVariables } from './file-view.graphql';

type FormData = GqlCreateFolderMutationVariables['input'];

export const CreateFolder = ({ close, parentId }: { close: () => void; parentId: string | null }) => {
  const [createFolder, { loading }] = useCreateFolderMutation({ refetchQueries: [FileViewDocument] });
  const companyId = useCompanyId();
  const form = useForm<FormData>({
    defaultValues: {
      companyId,
      name: '',
      parentId,
    },
  });
  const onSubmit: SubmitHandler<FormData> = async input => {
    try {
      const res = await createFolder({
        variables: { input },
      });
      if (res.data?.createFolder.id) {
        close();
      } else {
        throw Error('unexpected');
      }
    } catch {
      toast({
        title: <Trans id="Error" />,
        description: <Trans id="Failed to create folder" />,
        severity: 'warning',
      });
    }
  };
  return (
    <Dialog open onClose={close}>
      <form onSubmit={form.handleSubmit(onSubmit)}>
        <DialogTitle onClose={close}>
          <Trans id="Create Folder" />
        </DialogTitle>
        <DialogContent>
          <Controller
            control={form.control}
            name="name"
            render={({ field }) => (
              <FormControl>
                <FormLabel>
                  <Trans id="Name" />
                </FormLabel>
                <Input {...field} />
              </FormControl>
            )}
          />
        </DialogContent>
        <DialogActions>
          <Button variant="outlined" onClick={close}>
            <Trans id="Cancel" />
          </Button>
          <Button type="submit" loading={loading}>
            <Trans id="Create" />
          </Button>
        </DialogActions>
      </form>
    </Dialog>
  );
};
